'use strict';

(function ($) {
  var methods = {
    init: function (/*options*/) {
      // options are not used
      //var opts = $.extend({}, $.fn.k2_autofocus.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('autofocus-init')) {
          return;
        }

        $this.addClass('autofocus-init');

        $this.focus();
      });
    }
  };

  $.fn.k2_autofocus = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_autofocus');
    }

  };

  $.fn.k2_autofocus.defaults = {

  };

})(jQuery);
